import RCPOHeader from './Header'
import { Footer as GassanFooter, Header as GassanHeader } from '@components/Page'
import React, { FC } from 'react'
import RCPOFooter from './Footer'
import { RolexRCPOPageTypeTracking } from './PageTypeTracking'

type RCPOPageTypes =
  | 'home page'
  | 'selection page'
  | 'model page'
  | 'certification page'
  | 'programme page'
  | 'contact page'
  | 'store contact page'
  | 'contact form page'

export type RCPOPageProps = {
  pageType: RCPOPageTypes
  productFamily?: string
  productRMC?: string
}

export const RCPOPage: FC<RCPOPageProps> = ({ children, ...props }) => {
  return (
    <>
      <RolexRCPOPageTypeTracking {...props} />
      <GassanHeader initialVariant="absolute" />
      <div className="mx-auto w-full max-w-[109rem]">
        <RCPOHeader />
        {children}
        <RCPOFooter />
      </div>
      <GassanFooter />
    </>
  )
}
